import { IAppPerformanceSurveyRepository } from "../../adapters/driven/repositories/appPerformanceSurveyRepository";

export const AppPerformanceSurveyServiceImplFactory = ({
  appPerformanceSurveyRepository,
}: {
  appPerformanceSurveyRepository: IAppPerformanceSurveyRepository;
}) => {
  const storeAppPerformanceSurvey: IStoreAppPerformanceSurvey = async (
    payload
  ) => {
    try {
      const apiPayload = {
        comment: payload.note || "",
        score: payload.rating,
        person_properties: {
          facility: payload.facilityName || "",
          name: payload.email || "", // Using email as name for now
        },
      };

      const response =
        await appPerformanceSurveyRepository.apiPostAppPerformanceSurvey(
          apiPayload
        );
      if (response.survey_response) {
        return {
          success: true,
          data: response.data,
        };
      } else {
        return {
          success: false,
          error: { message: response.message },
        };
      }
    } catch (error) {
      console.error("Failed to submit survey:", error);
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return { storeAppPerformanceSurvey };
};
